import { useEffect, useRef } from 'react';

export default function IntroSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = sectionRef.current?.querySelectorAll('.fade-in-child');
            children?.forEach((child, i) => {
              const el = child as HTMLElement;
              setTimeout(() => {
                el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
                el.style.opacity = '1';
                el.style.transform = 'translateY(0)';
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Text */}
          <div>
            <p
              className="fade-in-child text-[#0050B2] text-sm font-semibold uppercase tracking-widest mb-4"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Who We Are
            </p>
            <h2
              className="fade-in-child text-3xl lg:text-4xl font-bold text-[#001F4E] leading-snug mb-6"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Built on <br />
              <span className="text-[#0050B2]">Versatility</span>
            </h2>
            <p
              className="fade-in-child text-gray-600 text-base leading-relaxed mb-6"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Holston Development Group stands apart with versatility rarely found in traditional companies.
              With over 60 years of combined experience, we adapt seamlessly to evolving demands,
              ensuring innovative solutions for every project.
            </p>
            <p
              className="fade-in-child text-gray-600 text-base leading-relaxed"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              Our multi-discipline structure allows us to serve complex industries with precision,
              from telecommunications engineering to land and site services, all under one group.
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-6">
            {[
              { value: '60+', label: 'Years Combined Experience', icon: 'ri-award-line' },
              { value: '20+', label: 'States Served Nationwide', icon: 'ri-map-pin-line' },
              { value: '1000+', label: 'Combined Projects Completed', icon: 'ri-checkbox-circle-line' },
              { value: 'Multi', label: 'Discipline Expertise', icon: 'ri-tools-line' },
            ].map((stat, i) => (
              <div
                key={i}
                className="fade-in-child bg-[#E8EFF6] rounded-lg p-6 text-center"
                style={{ opacity: 0, transform: 'translateY(20px)' }}
              >
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className={`${stat.icon} text-2xl text-[#0050B2]`} />
                </div>
                <p className="text-2xl lg:text-3xl font-bold text-[#001F4E] mb-1">{stat.value}</p>
                <p className="text-xs text-gray-500 font-medium leading-snug">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
